module.exports = __webpack_public_path__ + "static/media/RP_lakeside_at_town.69724d87.jpg";